export default "__VITE_ASSET__DHnZ$zVf__"